import styled from 'styled-components'

export const Root = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;

  & svg {
    width: 16px;
    height: 16px;
  }
`
